import React from 'react';
import { cond, is, find, prop, propEq, sortBy } from 'ramda';
import { BLOCK_ELEMENTS } from '../../utils/constants';
import {useIntl} from 'gatsby-plugin-intl';
import { 
  Title,
  Container, 
  CardWrapper, 
  } from './rowCard.styles';
import { ExpandableCard } from '../expandableCard';
import { renderWhenTrueOtherwise, renderWhenTrue } from '../../utils/rendering';
import { useBreakpointsContext } from '../../store/BreakpointsContext';

const renderTitle = ({ value }, key, isTabletOrGreater) => {
  const { formatMessage } = useIntl();
  return <Title key={key}>{formatMessage({id:value})}</Title>;
};

const renderCard = ({ elements = [] }, key) => {
  const cardTitle = find(propEq('name', 'plain_text'))(elements) || {};
  const cardIcon = find(propEq('name', 'image'))(elements) || {};
  const connection = find(propEq('name', 'connection'))(elements) || {};
  const citation = find(propEq('name', 'citation'))(elements) || {};
  const markdown = find(propEq('name', 'markdown'))(elements) || {};
  return (
    <ExpandableCard 
      key={key} 
      cardTitle={cardTitle} 
      cardIcon={cardIcon}
      connection={connection}
      citation={citation}
      markdown={markdown}
    />
  )
};

const renderCards = ({ value = [] }, key) => (
  <CardWrapper key={key}>{sortBy(prop('order'))(value).map(renderCard)}</CardWrapper>
);

const renderElement = cond([
  [propEq('name', 'Title'), renderTitle],
  [propEq('name', 'Card'), renderCards],
]);

export const RowCard = ({ elements }) => {
  const orderedElements = sortBy(prop('order'))(elements);
  const { isTabletOrGreater } = useBreakpointsContext();

  const renderCards = () => (
    <Container>
      {orderedElements.map((value, key) => renderElement(value, key, isTabletOrGreater))}
    </Container>
  );


  const mainContent = renderWhenTrueOtherwise(renderCards, renderCards);

  return mainContent(isTabletOrGreater);
};